import { useEffect, useMemo, useRef, useState } from "react"
import { useEntidad, useForm, useLista, useManagedContext } from "../../components/hooks"
import { ServerRequest } from "../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { InputNumber, InputUsuario, SectionHeading, SelectorButtons, TableCustom } from "../../components/common"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import { MEDIO_PAGO } from "../../consts/medioPago"
import { getDateToString, getFormatNumber } from "../../utils/convert"
import { CloneObject, GetValuesResumen } from "../../utils/helpers"
import { getAccess } from "../../utils/access"
import { ESTADO_CAJA } from "../../consts/estadoCaja"
import { TIPO_MOVIMIENTO_CAJA } from "../../consts/tipoMovimientoCaja"
import MovimientoCajaModal from "../../components/controls/MovimientoCajaModal"
import { isValidNumber } from "../../utils/validator"
import { OpenObjectURL } from "../../utils/helpers"
import { impresionConfigurada, printTicket, printTickets, puedeImprimir } from "../../utils/printTicket"
import { useReporte } from "../../components/hooks/useReporte"
import MovimientosCajaDetalleModal from "../../components/controls/MovimientosCajaDetalleModal"
import ReimprimirTicketsModal from "../../components/controls/ReimprimirTicketsModal"
import CobranzasModal from "../../components/controls/CobranzasModal"
import AnularMovimientoModal from "../../components/controls/AnularMovimientoModal"


const cajaDtoInit = {
    caja: {
        id: 0,
        codigo: '',
        nombre: '',
        orden: 0,
        idDependencia: 0,
        idEstadoCaja: 0,
        idUsuarioActual: 0,
        idCajaAsignacionActual: 0,
        idRecaudadora: 0
    },
    asignacion: {
        id: 0,
        idCaja: 0,
        idUsuario: 0,
        fechaApertura: null,
        fechaCierre: null,
        importeSaldoInicial: 0,
        importeSaldoFinal: 0,
        idRecaudacionLote: 0
    },
    movimientos: []
}
const aperturaInit = {
    idDependencia: 0,
    idCaja: 0,
    saldoActual: 0
}
const cobranzaInit = {
    efectivo: 0,
    tarjetaCredito: 0,
    tarjetaDebito: 0,
    cheque: 0,
    transferencia: 0,
    qr: 0,
    cobranzas: 0,
    saldoInicial: 0,
    ingresos: 0,
    retiros: 0,
    saldoFinal: 0
}

const MEDIO_PAGO_RESUMEN = {
    [MEDIO_PAGO.EFECTIVO]: { campo: 'efectivo', label: 'Efectivo' },
    [MEDIO_PAGO.TARJETA_CREDITO]: { campo: 'tarjetaCredito', label: 'Tarjeta de crédito' },
    [MEDIO_PAGO.TARJETA_DEBITO]: { campo: 'tarjetaDebito', label: 'Tarjeta de débito' },
    [MEDIO_PAGO.CHEQUE]: { campo: 'cheque', label: 'Cheques' },
    [MEDIO_PAGO.TRANSFERENCIA]: { campo: 'transferencia', label: 'Transferencias' },
    [MEDIO_PAGO.QR]: { campo: 'qr', label: 'QR' }
}

const AccesoCajasView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()

    const [state, setState] = useState({
        idUsuarioLogin: 0
    })
    const [cajaResumen, setCajaResumen] = useState(cajaDtoInit)
    const [apertura_formValues, , apertura_formReset, apertura_formSet ] = useForm(aperturaInit, "apertura_")
    const [formValues, , , formSet ] = useForm(cobranzaInit)

    const [showAperturaCaja, setShowAperturaCaja] = useState(false)
    const [showMovimientoCaja, setShowMovimientoCaja] = useState(false)
    const [showMovimientoCajaDetalle, setShowMovimientoCajaDetalle] = useState(false)
    const [idMovimientoCajaDetalle, setIdMovimientoCajaDetalle] = useState(0)
    const [idTipoMovimientoCaja, setIdTipoMovimientoCaja] = useState(0)
    const [showReimprimirTickets, setShowReimprimirTickets] = useState(false)
    const [reimprimirData, setReimprimirData] = useState(null)
    const [reimprimirExpectedCount, setReimprimirExpectedCount] = useState(0)
    const reimprimirPendingIdRef = useRef(null)
    const [showCobranzasModal, setShowCobranzasModal] = useState(false)
    const [showAnularMovimiento, setShowAnularMovimiento] = useState(false)
    const [movimientoAnular, setMovimientoAnular] = useState(null)
    const [mediosPagoLista, setMediosPagoLista] = useState([])
    const [accordions, setAccordions] = useState({
        movimientos: true,
        resumen: true
    })

    useEffect(() => {
        const access = getAccess();
        setState(prevState => {
            return {...prevState, idUsuarioLogin: access.idUsuario};
        });
    }, []);

    useEffect(() => {
        if (state.idUsuarioLogin > 0) {
            FindCaja_UsuarioLogin();
        }
    }, [state.idUsuarioLogin]);

    useEffect(() => {

        const {
            efectivo,
            tarjetaCredito,
            tarjetaDebito,
            cheque,
            transferencia,
            qr,
            cobranzas,
            saldoInicial,
            ingresos,
            retiros,
            saldoFinal
        } = GetValuesResumen(cajaResumen.asignacion.importeSaldoInicial, cajaResumen.movimientos)

        formSet({...formValues,
            efectivo: efectivo,
            tarjetaCredito: tarjetaCredito,
            tarjetaDebito: tarjetaDebito,
            cheque: cheque,
            transferencia: transferencia,
            qr: qr,
            cobranzas: cobranzas,
            saldoInicial: saldoInicial,
            ingresos: ingresos,
            retiros: retiros,
            saldoFinal: saldoFinal
        })

    }, [cajaResumen])

    const [getListEntidad] = useEntidad({
        entidades: ['Dependencia', 'Caja'],
        onLoaded: (_, isSuccess, error) => {
          if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
          key: 'Dependencia_Caja',
          timeout: 0
        }
    })

    const [getListLista, getRowLista ] = useLista({
        listas: ['TipoMovimientoCaja','MedioPago'],
        onLoaded: (_, isSuccess, error) => {
          if (!isSuccess) return ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
          setMediosPagoLista(getListLista('MedioPago'))
        },
        memo: {
          key: 'TipoMovimientoCaja_MedioPago',
          timeout: 0
        }
    })

    const mediosPagoOrdenados = useMemo(() => [...mediosPagoLista].sort((a, b) => a.orden - b.orden), [mediosPagoLista])

    const [ generateReporte, ] = useReporte({
        callback: (reporte, data, message) => {
            if (data) {
                if (reporte === "CajaTicketIndividual") {
                    if (reimprimirPendingIdRef.current === null) return
                    reimprimirPendingIdRef.current = null
                    setReimprimirData(data)
                }
                else {
                    printTicket(data)
                }
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message)
                if (reporte === "CajaTicketIndividual") {
                    reimprimirPendingIdRef.current = null
                    setShowReimprimirTickets(false)
                    setReimprimirData(null)
                }
            }
        },
        mode: 'json'
    })

    const [ generateReportePdf, ] = useReporte({
        callback: (reporte, buffer, message) => {
            if (buffer) {
                OpenObjectURL('CierreCaja.pdf', buffer)
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message)
            }
        },
        mode: 'blob'
    })

    
    const FindCaja_UsuarioLogin = () => {
        setIsLoading(true)

        const paramsUrl = `/usuario/login`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CAJA,
            paramsUrl,
            null,
            res => res.json().then(caja => {
                if (caja.id > 0) {
                    FindCaja_Resumen(caja.id, (cajaDto) => {
                        setCajaResumen(cajaDto)
                    })
                }
                else {
                    setShowAperturaCaja(true)
                }
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }
    const FindCaja_Resumen = (idCaja, callbackSuccess) => {
        setIsLoading(true)

        const paramsUrl = `/resumen/${idCaja}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CAJA,
            paramsUrl,
            null,
            res => res.json().then(cajaDto => {
                callbackSuccess(cajaDto);
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }
    const AbrirCaja = () => {

        setIsLoading(true)

        const paramsUrl = `/apertura/${apertura_formValues.idCaja}`
        const dataBody = {
            idUsuario: state.idUsuarioLogin
        }

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CAJA,
            paramsUrl,
            dataBody,
            res => res.json().then(({idCajaAsignacion}) => {
                FindCaja_Resumen(apertura_formValues.idCaja, (cajaDto) => {
                    setCajaResumen(cajaDto)
                })
                setShowAperturaCaja(false);
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }
    const CerrarCaja = () => {

        setIsLoading(true)

        const paramsUrl = `/cierre/${cajaResumen.caja.id}`

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CAJA,
            paramsUrl,
            null,
            res => res.json().then(({idCajaAsignacion}) => {
                emitirCajaCierre(idCajaAsignacion)
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'Cierre de caja exitoso')
                setCajaResumen(cajaDtoInit)
                apertura_formReset()
                setIsLoading(false)
                setShowAperturaCaja(true)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }
    const AnularMovimiento = (idMovimientoCaja, observacionAnulacion) => {

        setIsLoading(true)

        const paramsUrl = `/movimiento/anulacion/${idMovimientoCaja}`
        const dataBody = { observacionAnulacion }

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CAJA,
            paramsUrl,
            dataBody,
            res => res.json().then(({idCajaAsignacion}) => {
                FindCaja_Resumen(cajaResumen.caja.id, (cajaDto) => setCajaResumen(cajaDto))
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'Movimiento anulado exitosamente')
                generateReporte("CajaTicketAnulacion", { idMovimientoCaja })
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const handleIngresar = () => {
        setIdTipoMovimientoCaja(TIPO_MOVIMIENTO_CAJA.INGRESO)
        setShowMovimientoCaja(true)
    }
    const handleRetirar = () => {
        setIdTipoMovimientoCaja(TIPO_MOVIMIENTO_CAJA.RETIRO)
        setShowMovimientoCaja(true)
    }
    const handleAbrirCaja = () => {
        if (!isValidNumber(apertura_formValues.idCaja, true)) return ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe ingresar una caja')

        showMessageModal({
            title: "Confirmación",
            message: "¿Está seguro/a de abrir la caja?",
            onConfirm: () => AbrirCaja(),
        })
    }
    const handleCerrarCaja = () => {
        showMessageModal({
            title: "Confirmación",
            message: "¿Está seguro/a de cerrar la caja?",
            onConfirm: () => CerrarCaja(),
        })
    }

    const emitirCajaCierre = (idCajaAsignacion) => {
        const paramsReporte = {
            idCajaAsignacion: idCajaAsignacion
        }

        if (impresionConfigurada()) {
            generateReporte("CajaCierre", paramsReporte);
            return
        }

        generateReportePdf("CajaCierrePdf", paramsReporte);
    }

    const avmrMovimientos = {
        customActions: [
            {
                icon: 'search',
                title: 'Ver detalle del movimiento',
                onClick: ({ id }) => {
                    setIdMovimientoCajaDetalle(id)
                    setShowMovimientoCajaDetalle(true)
                },
                show: ({idTipoMovimientoCaja}) => (idTipoMovimientoCaja === TIPO_MOVIMIENTO_CAJA.COBRANZA)
            },
            {
                icon: 'delete',
                title: 'Anular movimiento',
                onClick: (row) => {
                    setMovimientoAnular(row)
                    setShowAnularMovimiento(true)
                },
                show: ({idTipoMovimientoCaja, anulado}) => (idTipoMovimientoCaja === TIPO_MOVIMIENTO_CAJA.COBRANZA && !anulado)
            },
            {
                icon: 'print',
                title: 'Reimprimir ticket',
                onClick: ({ id }) => {
                    if (!puedeImprimir()) return

                    const paramsReporte = {
                        idMovimientoCaja: id
                    }
                    generateReporte("CajaTicket", paramsReporte);
                },
                show: ({idTipoMovimientoCaja, anulado}) => (idTipoMovimientoCaja === TIPO_MOVIMIENTO_CAJA.COBRANZA && !anulado)
            },
            {
                icon: 'receipt_long',
                title: 'Reimprimir tickets individuales',
                onClick: (row) => {
                    if (!puedeImprimir()) return

                    reimprimirPendingIdRef.current = row.id
                    setReimprimirData(null)
                    setReimprimirExpectedCount(row.recibos?.length || 0)
                    setShowReimprimirTickets(true)
                    generateReporte("CajaTicketIndividual", { idMovimientoCaja: row.id })
                },
                show: ({idTipoMovimientoCaja, anulado}) => (idTipoMovimientoCaja === TIPO_MOVIMIENTO_CAJA.COBRANZA && !anulado)
            },
            {
                icon: 'print',
                title: 'Reimprimir ticket de anulación',
                onClick: ({ id }) => {
                    if (!puedeImprimir()) return

                    generateReporte("CajaTicketAnulacion", { idMovimientoCaja: id })
                },
                show: ({idTipoMovimientoCaja, anulado}) => (idTipoMovimientoCaja === TIPO_MOVIMIENTO_CAJA.COBRANZA && anulado)
            }
        ]
    }

    function ToggleAccordion(accordion) {
        let accordions2 = CloneObject(accordions);
        accordions2[accordion] = !accordions2[accordion];
        setAccordions(accordions2);
    }

    const accordionClose = <span className="material-symbols-outlined search-i">chevron_right</span>
    const accordionOpen = <span className="material-symbols-outlined search-i">expand_more</span>

    return <>
        <SectionHeading titles={[{ title: 'Cajas' }, { title: 'Acceso a cajas' }]} />

        {(showAperturaCaja &&
        <section className='section-accordion'>
            <div>
                <div>
                    <label className="form-label">Seleccioná una dependencia</label>
                    <SelectorButtons
                        items={getListEntidad('Dependencia').sort((a, b) => a.orden - b.orden)}
                        value={apertura_formValues.idDependencia}
                        onChange={(id) => {
                            apertura_formSet({...apertura_formValues, idDependencia: id, idCaja: 0, saldoActual: 0})
                        }}
                        labelFormat={(item) => item.nombre}
                    />
                </div>

                {apertura_formValues.idDependencia > 0 && (
                    <div className="mt-4">
                        <label className="form-label">Seleccioná una caja</label>
                        <SelectorButtons
                            items={getListEntidad('Caja').filter(row =>
                                row.idEstadoCaja === ESTADO_CAJA.CERRADA &&
                                row.idDependencia === apertura_formValues.idDependencia
                            ).sort((a, b) => a.orden - b.orden)}
                            value={apertura_formValues.idCaja}
                            onChange={(id) => {
                                apertura_formSet({...apertura_formValues, idCaja: id, saldoActual: null})
                                const paramsUrl = `/resumen/${id}`
                                ServerRequest(
                                    REQUEST_METHOD.GET, null, true, APIS.URLS.CAJA, paramsUrl, null,
                                    res => res.json().then(cajaDto => {
                                        apertura_formSet({...apertura_formValues, idCaja: cajaDto.caja.id, saldoActual: cajaDto.asignacion.importeSaldoFinal})
                                    }),
                                    res => onRequestNoSuccess(res),
                                    err => onRequestError(err),
                                )
                            }}
                            labelFormat={(item) => item.nombre}
                        />
                        {apertura_formValues.idCaja > 0 && (
                            <p className="form-label mt-4" style={{minHeight: '1.5em', display: 'flex', alignItems: 'center', gap: '4px'}}>
                                Saldo actual de la caja seleccionada: {apertura_formValues.saldoActual !== null
                                    ? `$${getFormatNumber(apertura_formValues.saldoActual, 2)}`
                                    : <span className="skeleton-text" />
                                }
                            </p>
                        )}
                    </div>
                )}
            </div>
        </section>
        )}

        {(cajaResumen.caja.id > 0 &&
        <section className='section-accordion'>
            <div>
                <div className="row form-basic">
                    <div className="col-12 col-lg-3">
                        <label htmlFor="nombre" className="form-label">Caja</label>
                        <input
                            name="nombre"
                            placeholder=""
                            className="form-control"
                            value={cajaResumen.caja.nombre}
                            disabled={true}
                        />
                    </div>
                    <div className="col-12 col-lg-5">
                        <label htmlFor="idUsuario" className="form-label">Usuario/a</label>
                        <InputUsuario
                            name="idUsuario"
                            placeholder=""
                            className="form-control"
                            value={cajaResumen.asignacion.idUsuario}
                            disabled={true}
                        />
                    </div>
                    <div className="col-6 col-lg-2">
                        <label htmlFor="fechaApertura" className="form-label">Apertura</label>
                        <input
                            name="fechaApertura"
                            placeholder=""
                            className="form-control"
                            value={getDateToString(cajaResumen.asignacion.fechaApertura,true)}
                            disabled={true}
                        />
                    </div>
                    <div className="col-6 col-lg-2">
                        <label htmlFor="importeSaldoInicial" className="form-label">Saldo inicial</label>
                        <input
                            name="importeSaldoInicial"
                            placeholder=""
                            className="form-control"
                            value={getFormatNumber(cajaResumen.asignacion.importeSaldoInicial,2)}
                            disabled={true}
                        />
                    </div>
                </div>

                <div className='accordion-header m-top-20'>
                    <div className='row'>
                        <div className="col-12" onClick={() => ToggleAccordion('movimientos')}>
                            <div className='accordion-header-title'>
                                {(accordions.movimientos) ? accordionOpen : accordionClose}
                                <h3 className={accordions.movimientos ? 'active' : ''}>Movimientos</h3>
                            </div>
                        </div>
                    </div>
                </div>
                {(accordions.movimientos &&
                <div className='accordion-body'>
                <>
                    <TableCustom
                        className={'TableCustomBase m-top-10'}
                        data={cajaResumen.movimientos}
                        avmr={avmrMovimientos}
                        columns={[
                            { Header: 'Tipo de movimiento', accessor: 'idTipoMovimientoCaja', width: '20%', Cell: ({ value }) => getRowLista('TipoMovimientoCaja', value)?.nombre ?? '' },
                            { Header: 'Fecha de movimiento', Cell: (data) => getDateToString(data.value, true), accessor: 'fechaCobro', width: '15%'},
                            { Header: 'Importe', Cell: (data) => getFormatNumber(data.value, 2), accessor: 'importeCobro', width: '15%', alignCell: 'right' },
                            { Header: 'Observación', accessor: 'observacion', width: '50%', Cell: ({ row }) => {
                                const m = row.original
                                if (m.anulado) {
                                    const texto = m.observacion ? `${m.observacion}\n` : ''
                                    return `${texto}Movimiento anulado el ${getDateToString(m.fechaAnulacion, true)}. Motivo: ${m.observacionAnulacion}`
                                }
                                return m.observacion
                            }},
                        ]}
                        showDownloadCSV={false}
                        showFilterGlobal={false}
                        getRowClassName={(row) => row.anulado ? 'rt-tr-anulado' : ''}
                    />
                    <div className="row form-basic m-top-10">
                        <div className="col-6">
                            <button className="btn btn-outline-primary" onClick={ (event) => setShowCobranzasModal(true) }>Abrir cobranzas</button>
                        </div>
                        <div className="col-6">
                            <button className="btn action-button float-end" onClick={ (event) => handleRetirar() }>Retirar dinero</button>
                            <button className="btn action-button float-end m-right-10" onClick={ (event) => handleIngresar() }>Ingresar dinero</button>
                        </div>
                    </div>
                </>
                </div>
                )}

                <div className='accordion-header m-top-10'>
                    <div className='row'>
                        <div className="col-12" onClick={() => ToggleAccordion('resumen')}>
                            <div className='accordion-header-title'>
                                {(accordions.resumen) ? accordionOpen : accordionClose}
                                <h3 className={accordions.resumen ? 'active' : ''}>Resumen diario</h3>
                            </div>
                        </div>
                    </div>
                </div>
                {(accordions.resumen &&
                <div className='accordion-body'>
                    <div className="row form-basic">
                        {mediosPagoOrdenados.map(medio => {
                            const campo = MEDIO_PAGO_RESUMEN[medio.id]?.campo ?? `medioPago${medio.id}`
                            return (
                                <div key={medio.id} className="col-12 col-lg-2 col-md-4">
                                    <label htmlFor={campo} className="form-label">{MEDIO_PAGO_RESUMEN[medio.id]?.label ?? medio.nombre}</label>
                                    <InputNumber
                                        precision={2}
                                        name={campo}
                                        placeholder=""
                                        className="form-control"
                                        value={formValues[campo] ?? 0}
                                        disabled={true}
                                    />
                                </div>
                            )
                        })}
                        <div className="col-12 col-lg-2 col-md-4">
                            <label htmlFor="cobranzas" className="form-label">Total cobranzas</label>
                            <InputNumber
                                precision={2}
                                name="cobranzas"
                                placeholder=""
                                className="form-control"
                                value={formValues.cobranzas}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row form-basic">
                        <div className="col-12 col-lg-2 col-md-4">
                            <label htmlFor="saldoInicial" className="form-label">Saldo inicial</label>
                            <InputNumber
                                precision={2}
                                name="saldoInicial"
                                placeholder=""
                                className="form-control"
                                value={formValues.saldoInicial}
                                disabled={true}
                            />
                        </div>
                        {(mediosPagoLista.some(medio => medio.id === MEDIO_PAGO.EFECTIVO) &&
                        <div className="col-12 col-lg-2 col-md-4">
                            <label htmlFor="efectivo" className="form-label">Cobranzas efectivo (+)</label>
                            <InputNumber
                                precision={2}
                                name="efectivo"
                                placeholder=""
                                className="form-control"
                                value={formValues.efectivo}
                                disabled={true}
                            />
                        </div>
                        )}
                        <div className="col-12 col-lg-2 col-md-4">
                            <label htmlFor="ingresos" className="form-label">Ingresos de dinero (+)</label>
                            <InputNumber
                                precision={2}
                                name="ingresos"
                                placeholder=""
                                className="form-control"
                                value={formValues.ingresos}
                                disabled={true}
                            />
                        </div>
                        <div className="col-12 col-lg-2 col-md-4">
                            <label htmlFor="retiros" className="form-label">Retiros de dinero (-)</label>
                            <InputNumber
                                precision={2}
                                name="retiros"
                                placeholder=""
                                className="form-control"
                                value={formValues.retiros}
                                disabled={true}
                            />
                        </div>
                        <div className="col-12 col-lg-2 col-md-4">
                            <label htmlFor="saldoFinal" className="form-label">Saldo final</label>
                            <InputNumber
                                precision={2}
                                name="saldoFinal"
                                placeholder=""
                                className="form-control"
                                value={formValues.saldoFinal}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
                )}
            </div>
        </section>
        )}

        {(showCobranzasModal &&
        <CobranzasModal
            cajaResumen={cajaResumen}
            onClose={() => setShowCobranzasModal(false)}
            onCobranzaRealizada={() => {
                FindCaja_Resumen(cajaResumen.caja.id, (cajaDto) => setCajaResumen(cajaDto))
            }}
        />
        )}

        {(showMovimientoCaja &&
        <MovimientoCajaModal
            idTipoMovimientoCaja={idTipoMovimientoCaja}
            cajaResumen={cajaResumen}
            onConfirm={() => {
                setIdTipoMovimientoCaja(0)
                setShowMovimientoCaja(false)
                FindCaja_Resumen(cajaResumen.caja.id, (cajaDto) => setCajaResumen(cajaDto))
            }}
            onCancel={() => {
                setIdTipoMovimientoCaja(0)
                setShowMovimientoCaja(false)
            }}
        />
        )}

        {(showMovimientoCajaDetalle && idMovimientoCajaDetalle > 0 &&
        <MovimientosCajaDetalleModal
            movimiento={cajaResumen.movimientos.find(f => f.id === idMovimientoCajaDetalle)}
            onCancel={() => {
                setShowMovimientoCajaDetalle(false)
                setIdMovimientoCajaDetalle(null)
            }}
        />
        )}

        {(showAnularMovimiento && movimientoAnular &&
        <AnularMovimientoModal
            movimiento={movimientoAnular}
            onConfirm={(observacion) => {
                setShowAnularMovimiento(false)
                AnularMovimiento(movimientoAnular.id, observacion)
                setMovimientoAnular(null)
            }}
            onCancel={() => {
                setShowAnularMovimiento(false)
                setMovimientoAnular(null)
            }}
        />
        )}

        {(showReimprimirTickets &&
        <ReimprimirTicketsModal
            boletas={reimprimirData?.boletas || []}
            loading={!reimprimirData}
            expectedCount={reimprimirExpectedCount}
            onConfirm={(selectedIndices) => {
                setShowReimprimirTickets(false)
                const selectedTickets = reimprimirData.tickets.filter((_, i) => selectedIndices[i])
                setReimprimirData(null)
                printTickets(selectedTickets)
            }}
            onCancel={() => {
                reimprimirPendingIdRef.current = null
                setShowReimprimirTickets(false)
                setReimprimirData(null)
            }}
        />
        )}


        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                {(showAperturaCaja &&
                    <button className="btn action-button float-end" onClick={ (event) => handleAbrirCaja() }>Abrir caja</button>
                )}
                {(cajaResumen.caja.id > 0 &&
                    <button className="btn action-button float-end" onClick={ (event) => handleCerrarCaja() }>Cerrar caja</button>
                )}
            </div>
        </footer>

    </>
}

export default AccesoCajasView
